// Upload History rows come from different backend paths (pending-applications list,
// XML upload response) that don't all use the same key name for the Encompass GUID.
export const getUploadHistoryItemGuid = (item) =>
	item?.loan_guid || item?.loanGuid || item?.loan_id || item?.loanId || item?.guid;
